// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, LitElement } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property } from 'lit/decorators.js';
import LightElement from './light-element.js';

@customElement('wishlist-button')
export default class WishlistButton extends LightElement {

	@property({ type: String })
	productName: string;

	@property({ type: Boolean })
	shiftLeft: boolean;

	@property({ type: Boolean })
	isInWishlist: boolean = false;

	connectedCallback() {
		super.connectedCallback();
		this.checkWishlistState();
		document.addEventListener('updateWishlistButtons', this.handleWishlistUpdate);
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		document.removeEventListener('updateWishlistButtons', this.handleWishlistUpdate);
	}

	handleWishlistUpdate = () => {
		this.checkWishlistState();
		this.requestUpdate();
	}

	checkWishlistState() {
		try {
			const ids = JSON.parse(localStorage.getItem('productIdsInWishlist') || '[]');
			this.isInWishlist = ids.includes(this.productName);
		} catch (e) {
			this.isInWishlist = false;
		}
	}

	render() {

		return html`
			<div class="c-product__wishlist-button js-add-to-wishlist-container">
				<div class="c-wishlist-add-button__tooltip ${this.shiftLeft ? 'c-wishlist-add-button__tooltip--shift-left' : ''} js-add-to-wishlist-tooltip" aria-hidden="true" data-test="product-card-add-to-wishlist-tooltip"></div>
				<button type="button" class="c-wishlist-add-button js-add-to-wishlist"
								data-wishlist-id="${this.productName}"
								data-wishlist-quantity="1"
								?data-in-wishlist="${this.isInWishlist}"
								?data-not-in-wishlist="${!this.isInWishlist}"
								data-test="product-card-add-to-wishlist-button">
					<span class="c-wishlist-add-button__text js-add-to-wishlist-text u-visuallyhidden">Add to wishlist</span>
					<img src="/images/icons/svgs/wishlist.svg?v=20708" class="c-wishlist-add-button__heart" height="24" width="24" loading="lazy" alt="" />
					<img src="/images/icons/svgs/wishlist-filled.svg?v=20708" class="c-wishlist-add-button__heart-full" height="24" width="24" loading="lazy" alt="" />
				</button>
			</div>
		`;

	}

}
